import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const STATEMENT_AGING_SCHEMA = Object.freeze({
  LB_STATEMENT_HEADER: '',
  LB_STATEMENT_DATE: '',
  LB_STATEMENT_FOR: '',
  LB_STATEMENT_SUMMARY: '',
  LB_SUMMARY_INVOICES: '',
  LB_SUMMARY_PAYMENTS: '',
  LB_SUMMARY_BALANCE: '',
  LB_DATE_RANGE: '',
  LB_INVOICE_DATE: '',
  LB_INVOICE_DETAILS: '',
  LB_INVOICE_AMOUNT: '',
  LB_INVOICE_PAID: '',
  LB_INVOICE_BALANCE: '',
  LB_OPENING_BALANCE: '',
  LB_DUE: '',
  LB_OVERDUE: '',
  LB_AMOUNT_DUE: '',
  LB_CURRENT_DUE: '',
  LB_OVERDUE_1_30DAYS: '',
  LB_OVERDUE_31_60DAYS: '',
  LB_OVERDUE_61_90DAYS: '',
  LB_OVERDUE_91DAYS: '',
  LB_CREDIT_MEMO: '',
});
const RECORD = generateSchema(STATEMENT_AGING_SCHEMA);
const KEYS: any = generateKeys(STATEMENT_AGING_SCHEMA);

export class StatementLabels extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }
}
